<template>
    <v-flex>
        <h1 class="display-3">Relación usuario -> cliente</h1>
        <v-container fluid>
            <v-layout>
                <v-flex xs12>
                    <v-card>
                        <v-card-title>
                            <v-autocomplete
                                    label="Seleccione Usuario"
                                    :items="users"
                                    v-model="user"
                                    item-value="id"
                                    item-text="name"
                                    return-object
                                    single-line
                                    hide-details
                                    @input="getVendedorClientes"
                            >
                            </v-autocomplete>
                            <v-btn @click.native="vinculaMicro" color="primary">
                                VINCULA MICROSIGA
                            </v-btn>
                            <v-btn @click.native="guardar" color="primary">
                                GUARDAR
                            </v-btn>
                            <v-checkbox label="Mostrar Vinculados" primary hide-details v-model="mostrarVinculado" @change="getClientes"></v-checkbox>
                            <v-spacer></v-spacer>
                            <v-text-field append-icon="search" hide-details single-line placeholder="Búsqueda" v-model="search" @change="getClientes"></v-text-field>
                        </v-card-title>
                        <v-layout>
                            <v-flex>
                                <v-data-table
                                        v-model="clientes_id"
                                        :headers="headers"
                                        :items="clientes"
                                        select-all
                                        item-key="id"
                                        :pagination.sync="pag"
                                        :loading="loadingCli"
                                        :rows-per-page-items="rows"
                                        rows-per-page-text="Filas por pagina"
                                        :total-items="totalItems"
                                        class="tabla-compacta"
                                >
                                    <template slot="items" slot-scope="props">
                                        <tr :active="props.selected" @click="props.selected = !props.selected">
                                            <td>
                                                <v-checkbox primary hide-details :input-value="props.selected"></v-checkbox>
                                            </td>
                                            <td>{{ props.item.rzon_soc }}</td>
                                            <td class="text-xs-center">{{ props.item.cuit }}</td>
                                            <td class="text-xs-center">{{ props.item.tel }}</td>
                                            <td class="text-xs-center">{{ props.item.dir }}</td>
                                            <td class="text-xs-center">{{ props.item.micro_id_1 }}</td>
                                            <td class="text-xs-center">{{ props.item.micro_id_2 }}</td>
                                            <td class="text-xs-center">{{ props.item.micro_id_3 }}</td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-flex>
</template>

<script>
    import mixUsers from '../../mixins/auth/users'
    import mixCliente from '../../mixins/cliente'

    export default {
        name: "add",
        mixins: [mixUsers, mixCliente],
        data() {
            return {
                mostrarVinculado: false,
                loadingCli: false,
                user: '',
                users: [],
                headers: [
                    {text: 'Razon social', value: 'rzon_soc', align: 'center'},
                    {text: 'CUIT', value: 'cuit', align: 'center'},
                    {text: 'Teléfono', value: 'tel', align: 'center'},
                    {text: 'Dirección', value: 'dir', align: 'center'},
                    {text: 'Id Friolatina', value: 'micro_id_1', align: 'center'},
                    {text: 'Id Bervill', value: 'micro_id_2', align: 'center'},
                    {text: 'Id Acerolatina', value: 'micro_id_3', align: 'center'},
                ],
                clientes_id: [],
                clientes: [],
                pag: {},
                rows: [10, 20, 30, {text: 'All', value: -1}],
                totalItems: 0,
                search:''
            }
        },
        watch: {
            pag: {
                handler() {
                    this.getClientes();
                },
                deep: true
            }
        },
        mounted() {
            this.usersList(r => {
                this.users = r;
            }, err => {
                console.log(err)
            });
            this.getClientes();
        },
        methods: {
            getClientes() {
                this.loadingCli = true;
                if (this.mostrarVinculado) {
                    this.pag.user_id = this.user.id;
                }else{
                    delete(this.pag.user_id);
                }
                this.pag.search = this.search;
                this.clienteIndex(this.pag, r => {
                    this.clientes = r.data;
                    this.totalItems = r.total;
                    this.loadingCli = false;
                }, err => {
                    console.log(err);
                    this.loadingCli = false;
                })
            },
            getVendedorClientes() {
                this.loadingCli = true;
                this.$http.post('vendedores/clientes', {user_id: this.user.id})
                    .then(r => {
                        this.clientes_id = r.data;
                        this.loadingCli = false;
                    })
            },
            guardar() {
                this.loadingCli = true;
                this.$http.post('vendedores/clientes-vincular', {user_id: this.user.id, clientes: this.clientes_id})
                    .then(r => {
                        this.loadingCli = false;
                    })
            },
            vinculaMicro(){
                this.loadingCli = true;
                this.$http.post('vendedores/clientes-vincular-micro', {user_id: this.user.id})
                    .then(r => {
                        this.loadingCli = false;
                    })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/auth/usuario_cliente.vue